module.exports = __webpack_public_path__ + "img/bohm.4126e7a2.svg";